import Loading from '@global/Loading'
import {
  getAuctionProperties,
  getInspectionProperties,
  getProperties,
} from '@lib/api-services/propertiesService'
import { getCookie, JWT_COOKIE } from '@lib/cookies'
import { listSearchPageType } from '@lib/variables'
import { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'

const LoadPrevPage = ({ queryParams, minPage, searchPageType, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [ref, inView] = useInView({
    threshold: 0.1,
    rootMargin: '200px 0px 200px 0px',
  })

  const token = getCookie(JWT_COOKIE)

  useEffect(() => {
    const getListing = async () => {
      setIsLoading(true)
      let properties = {}

      const params = { ...queryParams, page: minPage - 1 }

      switch (searchPageType) {
        case listSearchPageType.SEARCH_TYPE_PROPERTY: {
          properties = await getProperties(params, token || false)
          break
        }
        case listSearchPageType.SEARCH_TYPE_AUCTION: {
          params.has_auction = 'true'
          params.order_by = 'auction_date'
          properties = await getAuctionProperties(params, token || false)
          break
        }
        case listSearchPageType.SEARCH_TYPE_SALEDATE: {
          params.has_salebySetDate = 'true'
          params.order_by = 'salebySetDate'
          properties = await getProperties(params, token || false)
          break
        }
        case listSearchPageType.SEARCH_TYPE_INSPECTION: {
          properties = await getInspectionProperties(
            { ...params },
            token || false
          )
          properties.results = properties.results.map((it) => it.listing)
          break
        }
      }

      onSuccess?.(properties.results, params.page)
      setIsLoading(false)
    }

    if (inView && !isLoading && minPage > 1) {
      getListing()
    }
  }, [inView, minPage])

  return (
    <div ref={ref}>
      {isLoading && (
        <div style={{ padding: '0 0 40px' }}>
          <Loading inline />
        </div>
      )}
    </div>
  )
}

export default LoadPrevPage
